import MainPageLayout from "../../../layout/MainPageLayout";
import { FACTORY_CYLINDER_SETUP, FACTORY_SETUP } from "../../../api/allApi_List";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import spin from "../../../assets/icons/spin.png";
import JobCardForm from "../components/createJobcard/JobCardForm";
import useGetMultiple from "../../../CustomHooks/useAxios/useGetMultiple";
import NoCylinderAtFactory from "../components/createJobcard/NoCylinderAtFactory";

const JobCardPage = () => {
  const { data, isLoaded, error } = useGetMultiple([
    FACTORY_CYLINDER_SETUP,
    FACTORY_SETUP,
  ]);
  return (
    <MainPageLayout
      headerConfig={{ title: "Cylinder Job Card" }}
      bgColor="bg-dBlue-100"
    >
      {isLoaded && !error ? (
        data[0]?.length > 0 ? (
          <div className="form-container">
            <JobCardForm cylinderSetup={data[0]} factorySetup={data[1]} />
          </div>
        ) : (
          <NoCylinderAtFactory />
        )
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default JobCardPage;
